import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SocialGithubIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M12 1.99994C6.475 1.99994 2 6.59117 2 12.2537C2 16.7849 4.865 20.6275 8.8375 21.9823C9.3375 22.0788 9.52083 21.7614 9.52083 21.4892C9.52083 21.2457 9.5125 20.6005 9.50833 19.7458C6.72667 20.364 6.14 18.3701 6.14 18.3701C5.685 17.1867 5.0275 16.8702 5.0275 16.8702C4.12167 16.2345 5.0975 16.2476 5.0975 16.2476C6.10167 16.3189 6.62917 17.3041 6.62917 17.3041C7.52083 18.8719 8.97 18.4188 9.54167 18.1571C9.63167 17.4936 9.88917 17.0423 10.175 16.7858C7.95417 16.5293 5.62 15.6476 5.62 11.7189C5.62 10.5998 6.0075 9.68504 6.64917 8.96766C6.53667 8.70853 6.19917 7.66594 6.73667 6.25379C6.73667 6.25379 7.57417 5.97901 9.48667 7.30508C10.2867 7.07725 11.1367 6.96421 11.9867 6.959C12.8367 6.96421 13.6867 7.07725 14.4867 7.30508C16.3867 5.97901 17.2242 6.25379 17.2242 6.25379C17.7617 7.66594 17.4242 8.70853 17.3242 8.96766C17.9617 9.68504 18.3492 10.5998 18.3492 11.7189C18.3492 15.658 16.0117 16.5249 13.7867 16.7771C14.1367 17.0849 14.4617 17.7136 14.4617 18.6745C14.4617 20.0466 14.4492 21.1492 14.4492 21.4823C14.4492 21.7509 14.6242 22.0718 15.1367 21.9692C19.1375 20.6231 22 16.778 22 12.2537C22 6.59117 17.5225 1.99994 12 1.99994Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
